export default "__VITE_ASSET__DrpwZHBk__"